import { useQuery } from "react-query";
import { request } from "../../../config/helpers/axios-instance";
import { throwIfRequestError } from "../../hooks/request-error";

const fetchMedicineStock = async (medicineId, lookaheadDays) => {
    const result = await request({
        url: "inventory/medicine-stock",
        method: "GET",
        params: { medicineId, ...(lookaheadDays && { lookaheadDays }) },
    });
    throwIfRequestError(result);
    const body = result.data;
    if (!body?.success) throw body;
    return body.data;
};

// GET /api/inventory/medicine-stock?medicineId= — a cart line's batch-wise stock panel
// (2026-10-27; cart/BatchStockPanel.jsx). One medicine's eVital stock batch by batch, from ONE get_batches call, plus its
// shortage row recomputed from that exact stock:
//   { medicineId, readAt, onHand, stockUnknownReason, coverageWindowDays,
//     batches: [{ batch, expiry, quantity, counted, note }], row }
// Always read fresh (staleTime 0, no cache reuse across openings): the panel exists to show
// what eVital says right now, before an order is raised. `refetch` = "Re-read stock".
// `lookaheadDays` = the screen's reorder window, so the recomputed suggestion matches the table.
export default function useMedicineStock(medicineId, { enabled = true, lookaheadDays = null } = {}) {
    return useQuery(["procurement-medicine-stock", medicineId, lookaheadDays], () => fetchMedicineStock(medicineId, lookaheadDays), {
        enabled: enabled && !!medicineId,
        retry: false,
        staleTime: 0,
        cacheTime: 0,
        refetchOnWindowFocus: false,
    });
}
